import * as types from './mutation-types'
import storage from 'good-storage'
import { resizeFrame } from 'utils/mixin'
const postMsgToActIframe = menuId => {
  let frames = document.getElementsByTagName('iframe')
  // let activeFrame = document.getElementById(`iframe${menuId}`)
  // 考虑到系统管理和其他菜单模式下 只有一个 iframe存在
  let activeFrame = document.getElementById(`iframe${menuId}`) || document.getElementById('iseframe')
  if (activeFrame && menuId !== 'home') {
    for (let i = 0; i < frames.length; i++) {
      let preFrameWindow = frames[i].contentWindow
      if (preFrameWindow === activeFrame.contentWindow) {
        let _rect = activeFrame.getBoundingClientRect()
        let msg = {
          method: 'showTabCallback',
          argument: {
            pos: {
              left: _rect.left,
              top: _rect.top,
              width: _rect.width,
              height: _rect.height
            }
          }
        }
        let argus = JSON.stringify(msg)
        preFrameWindow.postMessage(argus, '*')
      } else {
        let msg = {
          method: 'hideTabCallback',
          argument: ''
        }
        let argus = JSON.stringify(msg)
        preFrameWindow.postMessage(argus, '*')
      }
    }
  } else if (menuId === 'home') {
    for (let i = 0; i < frames.length; i++) {
      let preFrameWindow = frames[i].contentWindow
      let msg = {
        method: 'hideTabCallback',
        argument: ''
      }
      let argus = JSON.stringify(msg)
      preFrameWindow.postMessage(argus, '*')
    }
  }
}
export default {
  [types.POST_MSG_TO_ACTIFRAME] (state, menuId) {
    postMsgToActIframe(menuId)
  },
  [types.SET_USER_INFO] (state, userInfo) {
    state.userInfo = userInfo
  },
  [types.SET_NAVIGATE_SCHEMA] (state, schema) {
    state.navigateSchema = schema
  },
  [types.SET_APP_MENUS] (state, menus) {
    state.appMenus = menus
  },
  [types.SET_SYSTEMT_MENUS] (state, menus) {
    state.systemMenus = menus
  },
  [types.SET_PERSONAL_MENUS] (state, menus) {
    state.personalMenus = menus
  },
  [types.SET_BASICINFO] (state, basicInfo) {
    state.basicInfo = basicInfo
  },
  [types.SET_TAB_MENUS] (state, menus) {
    state.tabMenus = menus
    state.navTabMenus = [...menus]
  },
  [types.ADD_TAB_MENUS] (state, menu) {
    if (state.navigateSchema !== '' && state.navigateSchema !== 'nav-type1') {
      return
    }
    state.tabMenus.push(menu)
    state.navTabMenus.push(menu)
  },
  [types.REMOVE_TAB_MENUS] (state, menuId) {
    state.tabMenus = state.tabMenus.filter(item => {
      return item.menuId !== menuId
    })
    state.navTabMenus = state.navTabMenus.filter(item => {
      return item.menuId !== menuId
    })
  },
  [types.SET_ACTIVE_TAB_MENU] (state, menuInfo) {
    if (menuInfo.menuId && state.activeTabMenu !== menuInfo.menuId) {
      // 1907视频控件消息兼容
      const {methods:{ _resizeFrame } } = resizeFrame
      postMsgToActIframe(menuInfo.menuId)
      // 1903视频控件消息兼容
      let params = {
        servFlag: 'tipSize',
        data: {
          menuId: menuInfo.menuId,
          menuCode: menuInfo.permissionCode
        }
      }
     // _resizeFrame() 视频控件1280一下样式问题，暂时不解决
      params = JSON.stringify(params)
      for (let i = 0; i < window.frames.length; i++) {
        window.frames[i].postMessage(params, '*')
      }
      state.activeTabMenu = menuInfo.menuId
      state.tabMenus.forEach(tab => {
        tab._closeable = state.activeTabMenu === tab.menuId
      })
      storage.session.set(`portal-active-tab-menu-${state.userName}`, menuInfo.menuId)
    }
  },
  [types.UPDATE_TAB_MENU_ITEM] (state, info) {
    let _menu = state.tabMenus.filter(
      item => item.menuId === state.activeTabMenu
    )[0]
    _menu._info = info
  },
  [types.SET_USER_NAME] (state, userName) {
    state.userName = userName
  },
  [types.SET_EXTEND_DATA] (state, { key, value }) {
    state.extendData[key] = value
  },
  [types.SET_TODO_MENU_ID] (state, todo) {
    state.todoMenuId = todo
  },
  [types.SET_MESSAGE_MENU_ID] (state, msg) {
    state.messageMenuId = msg
  },
  [types.SET_TAGS_DISPLAYBOARD] (state, tags) {
    state.tags_displayboard = tags
  },
  [types.SET_VIEW_TYPE] (state, type) {
    state.viewType = type
  },
  setUserName (state, userName) {
    state.userName = userName
  },
  // tabMenus重新排序
  [types.SORT_NAV_TAB_MENU] (state, { from, to }) {
    const tabMenus = storage.session.get(`portal-tab-menus-${state.userName}`)
    tabMenus.splice(to, 0, ...tabMenus.splice(from, 1))
    storage.session.set(`portal-tab-menus-${state.userName}`, tabMenus)
    // session 的顺序也需要调整
    state.navTabMenus.splice(to, 0, ...state.navTabMenus.splice(from, 1))
  }
}
